module.exports = __webpack_public_path__ + "static/media/sp_tutorial3.c6cc81bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/sp_tutorial3.png
// module id = 481
// module chunks = 0